const MAX_COMPOSER_HEIGHT_PX = 168

function bindTextarea(ta) {
  if (ta.dataset.roomComposerBound === '1') return
  ta.dataset.roomComposerBound = '1'

  const form = ta.closest('form')
  if (!form) return

  const resize = () => {
    ta.style.height = 'auto'
    const next = Math.min(ta.scrollHeight, MAX_COMPOSER_HEIGHT_PX)
    ta.style.height = `${next}px`
  }

  ta.addEventListener('input', resize)
  resize()

  ta.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || e.shiftKey) return
    e.preventDefault()
    const raw = ta.value
    if (!raw || !String(raw).trim()) return
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
    }
  })
}

function bindFormAjax(form) {
  if (!form || form.dataset.roomComposerAjaxBound === '1') return
  form.dataset.roomComposerAjaxBound = '1'
  form.addEventListener('ajax:complete', () => {
    const ta = form.querySelector('textarea.room-chat-composer-input')
    if (!ta || ta.value.trim()) return
    ta.style.height = 'auto'
    const next = Math.min(ta.scrollHeight, MAX_COMPOSER_HEIGHT_PX)
    ta.style.height = `${next}px`
  })
}

export function initRoomChatComposer() {
  document.querySelectorAll('.room-chat-composer textarea.room-chat-composer-input').forEach(bindTextarea)
  document.querySelectorAll('.room-chat-composer').forEach((wrap) => {
    bindFormAjax(wrap.closest('form'))
  })
}
